var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.districts_data != null
    ? _c(
        "div",
        { staticClass: "pl-1 list-es" },
        _vm._l(_vm.districts_data, function(district) {
          return _c("span", { key: district.id }, [
            _c(
              "span",
              {
                class: "badge badge-" + _vm.$root.network,
                on: {
                  click: function($event) {
                    return _vm.chooseDistrict(district.id)
                  }
                }
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(district["title"]) +
                    "\n            "
                ),
                district.count
                  ? _c(
                      "span",
                      { staticClass: "badge badge-light text-success" },
                      [_vm._v(_vm._s(district.count))]
                    )
                  : _vm._e(),
                _vm._v(" "),
                district.quarters && district.quarters.length > 0
                  ? _c(
                      "span",
                      [
                        _c("masked-image", {
                          staticClass: "badge-arrow",
                          attrs: { src: "/img/icons/arrow-list.svg" }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ]
            ),
            _vm._v(" "),
            district.quarters &&
            district.quarters.length > 0 &&
            _vm.district_open == district.id
              ? _c(
                  "ul",
                  _vm._l(district.quarters, function(quarter) {
                    return _c("li", { key: quarter.id }, [
                      _c("div", { staticClass: "form-check" }, [
                        _c("input", {
                          staticClass: "form-check-input",
                          attrs: {
                            type: "checkbox",
                            id: "input_" + district.id + "_" + quarter.id
                          },
                          domProps: {
                            checked: quarter.checked ? "checked" : "",
                            value: district.id + "|" + quarter.id
                          },
                          on: { change: _vm.selectQuarter }
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            class: quarter.checked ? "font-weight-bold" : "",
                            attrs: {
                              for: "input_" + district.id + "_" + quarter.id
                            }
                          },
                          [_vm._v(_vm._s(quarter.title))]
                        )
                      ])
                    ])
                  }),
                  0
                )
              : _vm._e()
          ])
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }